const SYNC_URL = '/api/sync';

export interface SyncConfig {
  role: string;
  masterAddress: string | null;
  masterPort: number | null;
  lastTestResult: string | null;
  lastTestAt: string | null;
  lastSync: string | null;
  lastSyncStatus: string | null;
}

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getSyncConfig(): Promise<SyncConfig> {
  return fetchJson<SyncConfig>(`${SYNC_URL}/client-status`);
}

export async function configureSync(host: string, port: number): Promise<{ success: boolean }> {
  return fetchJson<{ success: boolean }>(`${SYNC_URL}/config`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ host, port }),
  });
}

export async function testConnection(): Promise<{ reachable: boolean; error?: string }> {
  return fetchJson<{ reachable: boolean; error?: string }>(`${SYNC_URL}/test`, {
    method: 'POST',
  });
}

export interface MorningSyncResult {
  success: boolean;
  breakdownsImported: number;
  lebensplanImported: boolean;
}

export interface EveningSyncResult {
  success: boolean;
  statusUpdatesPushed: number;
}

export async function morningSync(): Promise<MorningSyncResult> {
  return fetchJson<MorningSyncResult>(`${SYNC_URL}/morning`, {
    method: 'POST',
  });
}

export async function eveningSync(): Promise<EveningSyncResult> {
  return fetchJson<EveningSyncResult>(`${SYNC_URL}/evening`, {
    method: 'POST',
  });
}

export const getSyncStatus = getSyncConfig;
